import React from 'react';
import { NumericFormat } from 'react-number-format';

const inputStyles = {
  backgroundColor: ' #fefefe',
  border: '1px solid #ccc',
  color: '#0a0a0a',
} as React.CSSProperties;

interface CurrencyInputWrapperProps {
  inputName: string;
  labelText: string;
  onChange: (value: string) => void;
  value: number;
}

const CurrencyInputWrapper = ({ inputName, labelText, onChange, value }: CurrencyInputWrapperProps) => {
  return (
    <>
      <label className="w-full text-left max-w-xs text-xs font-semibold" htmlFor={inputName}>
        {labelText}
      </label>
      <div className="input-container relative w-full">
        <NumericFormat
          className="appearance-none relative w-full h-10 box-border block overflow-visible p-2 mb-2 text-base rounded"
          id={inputName}
          name={inputName}
          onValueChange={values => onChange(values.value)}
          prefix="$"
          style={inputStyles}
          thousandSeparator=","
          type="text"
          value={value}
        />
      </div>
    </>
  );
};

export default CurrencyInputWrapper;
